import { render, staticRenderFns } from "./planoSemestraisInfantil.vue?vue&type=template&id=e32852c2"
import script from "./planoSemestraisInfantil.vue?vue&type=script&lang=js"
export * from "./planoSemestraisInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports